import { useDispatch, useSelector } from 'react-redux';
import React, { useEffect } from 'react';
import DocumentsLegacyRedux from '../../components/Documents';
import { selectAuthenticatedUser } from 'src/store/selectors/auth';
import {
  fetchFaqsNotesDocuments,
  deleteFaqsNotesDocuments,
} from 'src/store/actions/faqsNotesDocuments';
import { selectDocuments } from 'src/store/selectors/faqsNotesDocuments';
import { setSearch, clearSearch } from 'src/store/actions/search';
import { selectPRLoader } from 'src/store/selectors/PropertyLoader';
import Loader from '../../components/Loader';
import { sortDocumentsList } from 'src/helpers/CommonHelpers';
import { DocumentFormData } from 'src/utils/S3UploadDocumentsUtility';
import {
  useDocumentSave,
  UseDocumentSaveReturn,
} from 'src/pages/SharedPageCustomHooks/UseDocumentSave/useDocumentSave';

interface Item {
  id: string;
  name: string;
}

interface ItemDocumentsProps {
  item: Item;
}

const ItemDocuments = ({ item }: ItemDocumentsProps) => {
  const user = useSelector(selectAuthenticatedUser);
  const documents = useSelector(selectDocuments);
  const loader = useSelector(selectPRLoader);
  const dispatch = useDispatch();

  const { saveDocument }: UseDocumentSaveReturn = useDocumentSave({
    customErrorMessage:
      'Failed to upload this item document. Please try again or contact Juniper support if the issue persists.',
  });

  useEffect(() => {
    dispatch(fetchFaqsNotesDocuments(item.id));
    dispatch(clearSearch());
  }, [dispatch, item.id]);

  const onSave = async (document: DocumentFormData): Promise<void> => {
    await saveDocument(document, item.id, user.id);
  };

  const onDeleteFaqsNotesDocuments = (document: DocumentFormData): void => {
    document.Type = 'DOCUMENTS';
    dispatch(deleteFaqsNotesDocuments(document));
  };

  const sortDocuments = sortDocumentsList(documents);

  return loader ? (
    <Loader />
  ) : (
    <DocumentsLegacyRedux
      breadcrumb={item.name}
      documents={sortDocuments}
      onSaveDocument={(document) => onSave(document)}
      onDeleteDocument={(document: any) => onDeleteFaqsNotesDocuments(document)}
      onSearch={(e: any) =>
        dispatch(setSearch({ documents: e.target.value.trim() }))
      }
      labelName={'Manuals & Documents'}
    />
  );
};

export default ItemDocuments;
